export const queryParamsKey = {
  amount: "amount",
  lte: "amount_lte",
  gte: "amount_gte",
};

export const localeRoot = "settings.paywalls_admin_dashboard.filters.amount";
